import React, { useEffect } from 'react'

import './authPages.css'

import { ExclamationTriangleIcon } from '@heroicons/react/20/solid'
import { clearSession } from '../../services/sessionCookie'

function LoggedOutModa() {
	useEffect(() => {
		const handleStorageChange = (event) => {
			if (event.key === 'jwtToken' && event.newValue) {
				const modal = document.querySelector('#modalForOtherAccountLoggedIn')
				if (modal) {
					modal.classList.remove('modal-open')
				}
			}
		}

		window.addEventListener('storage', handleStorageChange)
		return () => window.removeEventListener('storage', handleStorageChange)
	}, [])

	const clickHandler = async () => {
		try {
			const axios = (await import('axios')).default
			await axios.post('/api/user/logout-session')
		} catch {
			// Session may already be invalid, continue to login
		}

		clearSession()
		localStorage.removeItem('email')
		window.location.href = '/account/login'
	}
	return (
		<>
			<dialog id="modalForOtherAccountLoggedIn" className="modal">
				<form method="dialog" className={`modal-box searches-modal-box-custom`}>
					<div className="flex items-center">
						<ExclamationTriangleIcon className="text-red-600 w-7 h-7 mr-2" />
						<h2 className="font-bold text-lg text-gray-200">
							Session Expired or Terminated!
						</h2>
					</div>
					<p className="text-lg pt-4 py-2 text-gray-200">
						Your session has expired or been terminated. This could be due to
						inactivity, logging in from another device. Please log in again to
						continue.
					</p>

					<div className="modal-action">
						<button onClick={clickHandler} className="btn btn-info">
							Login
						</button>
					</div>
				</form>
			</dialog>
		</>
	)
}

export default LoggedOutModa
